import { OrgSelectLocale } from "..";

const locale: OrgSelectLocale = {
  placeholder: '点击搜索',
  title: "组织搜索",
};

export default locale
